export default __webpack_public_path__ + "static/media/jewelry.920d2287.png";